var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Valid_XML",
    "data-name": "Invalid XML Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 22,
    viewBox: "0 0 38 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_6612",
    "data-name": "Path 6612",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H31.757V14.2H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.9999980926513672 0.9999971389770508 L 0.9999980926513672 13.19775676727295 L 30.75683784484863 13.19775676727295 L 30.75683784484863 0.9999971389770508 L 0.9999980926513672 0.9999971389770508 M -1.9073486328125e-06 -2.86102294921875e-06 L 31.75683784484863 -2.86102294921875e-06 L 31.75683784484863 14.19775676727295 L -1.9073486328125e-06 14.19775676727295 L -1.9073486328125e-06 -2.86102294921875e-06 Z",
    stroke: "none",
    fill: "#70c38a"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "XML",
    transform: "translate(5.878 10.599)",
    fill: "#70c38d",
    fontSize: 9.5,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "XML"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidXml);
export default __webpack_public_path__ + "static/media/valid_xml.0a41ba42b5ac1cc90108de4d7245880f.svg";
export { ForwardRef as ReactComponent };